<template>
    <div>
        <b-dropdown-form style="width: 20rem;" class="mt-3">
            <b-input-group prepend="$" size="sm">
                <b-input type="number" v-model="amount" placeholder="Amount" ></b-input>
            </b-input-group>

            <b-select :options="options" v-model="type" size="sm" class="mt-3">
                <template #first>
                    <b-form-select-option :value="null" disabled>Type</b-form-select-option>
                </template>
            </b-select>

            <b-input-group prepend="Note" size="sm" class="mt-3">
                <b-input v-model="note"></b-input>
            </b-input-group>

            <div class="text-right mt-3">
                <b-button v-if='hasInitialValues' :disabled="!hasInitialValues" @click="deleteDiscount()" size="sm" variant="warning" class="mr-2">Delete</b-button>
                <b-button :disabled="!hasValues" @click="doDiscount()" size="sm" variant="primary">{{hasInitialValues ? 'Update' : 'Add Discount'}}</b-button>
            </div>
        </b-dropdown-form>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "Discount",
        props: ['initialAmount', 'initialType', 'initialNote', 'initialDate'],
        data() {
            return {
                amount: this?.initialAmount || null,
                type: this?.initialType || null,
                note: this?.initialNote || null,
                options: [
                    'Item',
                    'Quantity',
                    'Shipping',
                    'Not as described',
                    'Alternate item',
                    'Grandfathered',
                    'Employee',
                    'Dealer',
                    'Credit',
                    'One Time Deal',
                    'Ongoing Deal',
                ],
            }
        },
        methods: {
            doDiscount() {
                const discountObj = {
                    username: this.$auth.user.nickname,
                    amount: this.amount,
                    type: this.type,
                    note: this.note,
                    date: this.initialDate || moment().format(),
                };

                this.$emit('addDiscount', discountObj);

                if (!this.initialAmount) {
                    this.amount = null;
                    this.type = null;
                    this.note = null;}
            },
            deleteDiscount() {
                this.$emit('removeDiscount', this.amount)
            }
        },
        computed: {
            hasValues() {
                return this.amount && this.type ? true : false;
            },
            hasInitialValues() {
                return this.initialAmount && this.initialType ? true : false;
            }
        },
    }
</script>

<style scoped>

</style>